// extracted by mini-css-extract-plugin
export default {"root":"WhatsNewCard_root__UTDkI"};